import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CreateVendorButton: React.FunctionComponent = () => (
    <div className={classNames('text-right w-100')}>
        <Link to={Router.generate(routes.VENDOR_CREATE)} className={`${'btn btn-success'}`}>
            <FontAwesomeIcon className={'mr-1'} icon={faPlus} />
            <span style={{ fontWeight: 'bold' }}>Add New Vendor</span>
        </Link>
    </div>
);

export default CreateVendorButton;
